import { AxiosInstance } from 'axios'
import { BaseApi } from '@/api/BaseApi'
import { CityApiRequest, CityApiResponse } from '@/types/common/city'

export const PATH = {
  POST_CITY: '/api/common/city',
} as const

export class CityApi {
  baseApi: BaseApi
  constructor(axios: AxiosInstance) {
    this.baseApi = new BaseApi(axios)
  }

  /**
   * 市区町村情報取得
   */
  public async postCity(prefId: string): Promise<CityApiResponse> {
    const { data } = await this.baseApi.post<CityApiRequest, CityApiResponse>(PATH.POST_CITY, { pref: prefId })
    return data
  }
}
